import React from 'react'

import ApplicationProcessIcon from '@zet/svg/applicationProcess'
import BrandBenifitsIcon from '@zet/svg/brandBenifits'
import EligibilityCreteriaIcon from '@zet/svg/eligibilityCreteria'
import HelpSupportIcon from '@zet/svg/helpSupport'
import MarketingResourcesIcon from '@zet/svg/marketingResources'
import TrainingAndEarningIcon from '@zet/svg/trainingAndEarning'

const renderIcon = [
  {
    id: 'index-1',
    iconName: <BrandBenifitsIcon />,
    title: 'customerCategories.brandBenefits',
    navigationScreen: 'BrandBenefits',
  },
  {
    id: 'index-2',
    iconName: <ApplicationProcessIcon />,
    title: 'customerCategories.applicationProcess',
    navigationScreen: 'ApplicationProcess',
  },
  {
    id: 'index-3',
    iconName: <EligibilityCreteriaIcon />,
    title: 'customerCategories.eligibilityCriteria',
    navigationScreen: 'EligibilityCriteria',
  },
  {
    id: 'index-4',
    iconName: <TrainingAndEarningIcon />,
    title: 'customerCategories.trainingLearning',
    navigationScreen: 'BrandTrainings',
  },
  {
    id: 'index-5',
    iconName: <MarketingResourcesIcon />,
    title: 'customerCategories.marketingResources',
    navigationScreen: 'MarketingResource',
  },
  {
    id: 'index-6',
    iconName: <HelpSupportIcon />,
    title: 'customerCategories.helpSupport',
    navigationScreen: 'BrandsHelpAndSupport',
  },
]

const DUMMY_CARD_TYPES = [
  { id: 'index-1', cardText: 'SBI Air India Card', isActive: true },
  { id: 'index-2', cardText: 'SBI BHPL Card', isActive: false },
  { id: 'index-3', cardText: 'SBI Some Other', isActive: false },
]

const DUMMY_TERMS_TEXTS = [
  {
    id: 'terms-1',
    termsText: 'Fills the card application using your Zet Link',
  },
  { id: 'terms-2', termsText: 'Uses only one device to apply for card' },
  {
    id: 'terms-3',
    termsText: 'Activates the credit card after receiving it',
  },
]

const dummyPayoutTexts = [
  {
    id: 'index-1',
    payoutText:
      'Ask your customer to fill the application to get rejection payout',
  },
  {
    id: 'index-2',
    payoutText: 'Rejection payout is limited to 20 per month',
  },
]

const DUMMY_TILE_DATA = [
  {
    id: 'index-1',
    name: 'Eligible Customers',
    heading: '21',
    navigationScreen: '',
  },
  { id: 'index-2', name: 'Total Leads', heading: '03', navigationScreen: '' },
]

const Highlights = [
  {
    icon: '🆓',
    title: 'Zero Fee Variant',
    content: 'Apply using an existing credit card',
  },
  {
    icon: '🎁',
    title: 'Welcome Rewards',
    content: 'Apply using an existing credit card',
  },
  {
    icon: '🎁',
    title: 'Welcome Rewards',
    content: 'Apply using an existing credit card',
  },
  {
    icon: '🎁',
    title: 'Welcome Rewards',
    content: 'Apply using an existing credit card',
  },
  {
    icon: '🎁',
    title: 'Welcome Rewards',
    content: 'Apply using an existing credit card',
  },
]

export {
  renderIcon,
  DUMMY_CARD_TYPES,
  DUMMY_TERMS_TEXTS,
  dummyPayoutTexts,
  DUMMY_TILE_DATA,
  Highlights,
}
